import {actions} from './actions';
import {mutations} from './mutations';
import {getters} from './getters';
import {Module} from 'vuex';
import {RootState} from '@/store';
import {DataPointsResponse} from "@/models/response/BrainpowerApiResponse";

export interface DatapointsState{
    datapoints: DataPointsResponse
}

const initialState: DatapointsState = {
    datapoints: {} as DataPointsResponse,
}

export const datapoints: Module<DatapointsState, RootState> = {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
};
